<template>
  <v-layout align-start>
    <v-flex>
      <div id="app">
        <v-app id="inspire">
          <v-row justify="center">
            <v-col cols="12" sm="10" md="8" lg="12">
              <v-card ref="form">
                <v-card-text>
                  <v-col cols="12" md="12">
                    <v-alert type="info" class="subtitle-2 text-center" color="primary">CIERRE DIARIO</v-alert>
                  </v-col>
                  <div align="center">
                     <v-btn color="primary" @click="cambio" v-if="cierre">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="12" md="12" v-show="valida">
                      <v-row class="red--text" v-for="v in validamensaje" :key="v" v-text="v"></v-row>
                    </v-col>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-app>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      // Variable
      contrasenia1: "",
      contrasenia2: "",
      valida: 0,
      validamensaje: [],
      cierre:1
    };
  },

  methods: {
    cambio() {
  
      //Editar
      let me = this;
      let header = { Authorization:this.$store.state.token };
      let configuracion = { headers: header };
      
      me.cierre=0,

      axios
        .get(
          "api/parametros/cierre",
          configuracion
        )
        .then(function(response) {
          me.limpiar();
          me.$swal("Cierre Realizado Con Exito");
          me.$store.dispatch("salir");
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    limpiar() {
      this.contrasenia1 = "";
      this.contrasenia2 = "";
      this.valida = 0;
      this.validamensaje = [];
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.contrasenia1) {
        this.validamensaje.push("La Nueva Contraseña esta Vacia");
      }

      if (!this.contrasenia2) {
        this.validamensaje.push("La Confirmacion Nueva Contraseña esta Vacia");
      }

      if (this.contrasenia1 != this.contrasenia2) {
        this.validamensaje.push("Las Contraseñas no son Iguales");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    }
  }
};
</script>